import React, { useRef } from 'react';
import { classNames } from 'primereact/utils';
import { TableOrderArrow } from '../../atoms';
import { Tooltip, TOOLTIP_SURFACE } from '../../atoms/Tooltip';

interface DataTableSortingIndicatorProps {
  isSorted: 'asc' | 'desc' | false;
  containerClassName?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const DataTableSortingIndicator: React.FC<DataTableSortingIndicatorProps> = ({
  isSorted,
  containerClassName,
  onClick,
}) => {
  const ascRef = useRef<HTMLDivElement>(null);
  const descRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div
        onClick={onClick}
        className={classNames('flex flex-col items-center justify-center gap-1 pl-2', containerClassName)}
      >
        <div ref={ascRef}>
          <TableOrderArrow
            className={classNames({
              '[&>path]:fill-fletchers-green-800': isSorted === 'asc',
            })}
          />
        </div>
        <div ref={descRef}>
          <TableOrderArrow
            className={classNames('rotate-180', {
              '[&>path]:fill-fletchers-green-800': isSorted === 'desc',
            })}
          />
        </div>
      </div>
      <Tooltip
        target={ascRef as React.RefObject<HTMLElement>}
        content="Sort by ascending"
        position="top"
        className={TOOLTIP_SURFACE}
      />
      <Tooltip
        target={descRef as React.RefObject<HTMLElement>}
        content="Sort by descending"
        position="top"
        className={TOOLTIP_SURFACE}
      />
    </>
  );
};
